import NewsService from '@/lib/News';
import { useQuery } from '@tanstack/react-query';
import useCurrentUser from './useCurrentUser';

export default function useAssetNews(symbol: string, limit: number, isCrypto = false) {
    const { data: user } = useCurrentUser();

    const query = useQuery({
        queryKey: ['assetNews', symbol],
        queryFn: () => NewsService.getNews([symbol], isCrypto, limit),
        enabled: !!symbol && !!user,
        staleTime: 1 * 60 * 1000,
        refetchOnWindowFocus: false,
    });

    return query;
}